import { getCurrencyConfig } from './currency-config';

function serializeCurrency(price: string, symbol: string, placement: 'prefix' | 'suffix') {
  return placement === 'prefix' ? `${symbol}\u00A0${price}` : `${price}\u00A0${symbol}`;
}

interface CurrencyFormatOptions {
  defaultCurrency?: string;
  displayIsoCode: boolean;
  placeCurrencyBefore?: boolean;
}

export function createCurrencyFormatFn(options: CurrencyFormatOptions) {
  return (priceStr: string, currencyParam?: string) => {
    const currency = currencyParam ?? options.defaultCurrency ?? '';

    if (options.displayIsoCode) {
      const placement = options.placeCurrencyBefore ? 'prefix' : 'suffix';
      return serializeCurrency(priceStr, currency, placement);
    }

    const currencyConfig = getCurrencyConfig(currency);
    if (!currencyConfig) {
      return priceStr;
    }

    // in case of symbol override "placeCurrencyBefore".
    return serializeCurrency(priceStr, currencyConfig.symbol, currencyConfig.placement);
  };
}
